// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"fa0527ae","72":"073f73f7","477":"e3b1e5f7","627":"364d0a67","663":"edd08bff","667":"d6baa2e2","777":"395ac711","803":"6eb9bb75","820":"c1e5d615"}[chunkId] + ".chunk.js";
};